import React, {FC, useState} from 'react';

import {Modal, zIndex} from '@optimaxdev/design-system';

import s from './giftFreeGlassesPopup.scss';

const modalOptions = {
    blank: false,
    options: {
        withBorderRadius: true,
    },
    overlay: 'dark' as const,
    withoutCloses: false,
    zIndex: zIndex.popup,
};

const DETAILS = [
    {
        id: 0,
        text: 'Find your perfect pair from 1000s of stylish eyeglass & sunglass frames.',
    },
    {
        id: 1,
        text: 'Single vision prescription lenses (value package) included with eyeglasses frames.',
    },
    {
        id: 2,
        text: 'Not eligible for premium tagged frames & Readers category items.',
    },
    {
        id: 3,
        text: 'Limited for 1 use only.',
    },
    {
        id: 4,
        text: 'Any other lens package, prescription or upgrade, is available at additional cost.',
    },
];

/**
 * "Learn more" popup for Vista Gift item on the cart
 *  @returns {React.ReactElement} - rendered component
 */
export const GiftFreeGlassesPopup: FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button className={s.learnMore} onClick={() => setIsOpen(true)} type="button">
                Learn more
            </button>
            <Modal isOpen={isOpen} {...modalOptions} onRequestClose={() => setIsOpen(false)}>
                <section className={s.container}>
                    <h1 className={s.title}>Get FREE glasses with your Vista plus order!</h1>
                    <ul>
                        {DETAILS.map(({id, text}) => (
                            <li className={s.detail} key={id}>
                                <p>{text}</p>
                            </li>
                        ))}
                    </ul>
                </section>
            </Modal>
        </>
    );
};
